const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Preferências de Leads',
    confirmMessage: 'Tem certeza de que deseja salvar suas preferências de lead e ir para a página Adicionar usuário?',
    notInterested: {
      radioOptions0: 'Falta de tempo/recursos para atender novos leads',
      radioOptions1: 'Interessado apenas em contratos de proprietário assinados',
      radioOptions2: 'Não quero divulgar faixa de preço',
      radioOptions3: 'Outro',
      selectReason: 'Selecione um motivo para desistir do programa Enphase Leads',
      otherComments: 'Algum outro comentário'
    },
    programOverview: {
      notInterestedText: 'Não estamos interessados em participar do programa Enphase Leads no momento'
    },
    serviceDetailsSection: {
      min: 'Min',
      max: 'Máx.',
      maxLessMin: 'O valor máximo não pode ser menor ou igual ao valor mínimo',
      enterInRange: 'Insira números entre %{serviceMInValue} e %{serviceMaxValue} apenas',
      note: 'Nota',
      noteText: 'Uma faixa de preço será mostrada ao proprietário com base nessa entrada. Este preço deve incluir impostos, mas não incentivos.',
      noteTextAus: 'Uma faixa de preço será mostrada ao proprietário com base nessa entrada. Este preço deve incluir o GST, mas não os incentivos.',
      sizeRange: 'Faixa de tamanho',
      pricePerkWh: 'Preço por kWh',
      lessThan20kWh: 'Menos de 20 kWh',
      greaterThan20kWh: '20 a 40 kWh'
    },
    serviceAreaSection: {
      title: 'Acesso de administrador e área de serviço',
      manageAdminAccess: 'Gerenciar acesso de administrador',
      addNewUser: '+ Adicionar novo usuário',
      selectOneAdmin: 'Selecione um usuário administrador de sua empresa que será o único ponto de contato caso a Enphase queira entrar em contato com você para escalonamentos relacionados a qualquer lead.',
      selectUser: 'Selecione o usuário',
      otherAdmin: '#Os outros usuários admin na lista acima ainda receberão alertas para todos os novos leads e suas atualizações. Eles podem desativá-los atualizando as preferências deles de notificação, se necessário.',
      serviceArea: 'Área de serviço',
      addServiceAreas: ''
    },
    addUserDialog: { 
      yes: 'Sim'
    },
    acModule: {
      optIn: 'Opt-in para instalação de Módulos CA Energizados da Enphase',
      description: 'O proprietário expressa interesse em um sistema baseado em Módulo CA. Você irá adquirir e instalar os Módulos CA. Os módulos CA energizados da Enphase combinam a mais recente tecnologia de microinversor de última geração da Enphase com os painéis solares de alta eficiência. Eles combinam estética e desempenho em um produto elegante que reduz o tempo de instalação ao combinar o inversor e o painel em uma única unidade.'
    },
    sampleQuotes: {
      title: 'Preços indicativos para leads',
      useSlider: 'Use os sliders abaixo para ver como suas entradas de faixa de preço são convertidas em uma faixa de preço indicativa para proprietários de casas para diferentes tamanhos de sistema',
      description: 'Com base em suas entradas, a faixa de preço indicativa que os proprietários verão será exibida aqui. Você também pode verificar como a faixa de preço varia de acordo com o tamanho do sistema.',
      solarOnly: 'Instalação solar',
      storageOnly: 'Instalação de armazenamento',
      solarStorage: 'Solar + Instalação de armazenamento',
      solarExpansion: 'Expansão solar',
      turnkeyACM: 'Instalação de armazenamento + atualização ACM',
      microUpgrade: 'Atualização de microinversor',
      turnkeyIQSeries: 'Instalação de armazenamento + atualização de microinversores',
      installationACM: 'Instalação de armazenamento + atualização ACM',
      installationIQSeries: 'Instalação de armazenamento + atualização de microinversores',
      installationSolar: 'Instalação solar',
      installationStorage: 'Instalação/expansão de armazenamento',
      turnkeyNew: 'Preço chave na mão para novos proprietários',
      turnKeyExisting: 'Preço chave na mão para proprietários existentes',
      turnkeyNewUS: 'Preço chave na mão para proprietários',
      installationUS: 'Preço de instalação apenas para proprietários',
      installation: 'Cotações de instalação apenas para clientes M-190 Micro',
      turnkeyPrice: 'Preço chave na mão',
      installation2: 'Preço de instalação apenas para clientes de referência',
      installation3: 'Preço apenas de instalação',
      microinverterFootnote: 'O preço de atualização do microinversor pode ser adicionado, dependendo da idade da unidade',
      solar: 'Solar',
      storage: 'Armazenar'
    },
    operationMaintenance: {
      label: 'Opt-in para serviços de O&M',
      description: 'Os serviços de Operações e Manutenção (O&M) incluem o suporte e manutenção de sistemas Enphase existentes e Sistemas Órfãos (unidades com uma instaladora inativa). Todos os leads de O&M receberão detalhes completos e histórico de suporte da unidade. Para todos os leads de O&M, a garantia padrão do produto da Enphase será aplicada. A garantia de fabricação anterior não se aplica aos Sistemas Órfãos.'
    },
    leadProgram: {
      optIn: 'Opt-in para o programa Enphase Leads',
      description: 'Os responsáveis contatam a Enphase para novas instalações, atualizações e manutenção contínua do sistema. Como um parceiro da Enphase, você agora tem a oportunidade de atender a esses proprietários por meio do Programa Enphase Leads, que irá combiná-lo com os proprietários em potencial.',
      programHighlights: 'Destaques do programa:',
      keyTerms1: 'A Enphase fornecerá leads qualificados gratuitos proveniente da sua área de atendimento ao cliente',
      keyTerms2: 'O perfil do cliente e os detalhes de projeto de cada lead serão fornecidos antes do primeiro contato',
      keyTerms3: 'A Enphase ajudará com a programação, o agendamento da visita, as atualizações do projeto e o suporte técnico',
      keyTerms4: 'Espera-se que as instaladoras respondam/façam contato com cada lead e enviem um orçamento em até 2 dias úteis',
      keyTerms5: 'Como regra do programa, devem ser usados apenas produtos da Enphase',
      leadProgramPreferences: 'Preferências do programa de Lead',
      someLeads: 'Alguns leads podem exigir apenas serviços de instalação. Indique abaixo se deseja aceitar esses leads.',
      tooltipTitle1: 'Serviços que você fornece aos proprietários. A Enphase irá combiná-lo com os proprietários com base nas suas preferências de serviço selecionadas',
      turnKey: 'Serviços chave na mão',
      tooltipTitle2: 'Você fornece todos os equipamentos, design, permissão e serviços de instalação',
      installationService: 'Serviços apenas de instalação',
      tooltipTitle3: 'O proprietário opta por adquirir o equipamento da Enphase na Enphase Store. Você fornece o equipamento restante, design, permissão e serviços de instalação',
      solarNew: 'Solar - Novas Instalações',
      solarUpgrades: 'Solar - atualizações',
      storageNew: 'Armazenamento - Novas instalações'
    },
    textContent: {
      preference: {
        title: 'Preferências do programa de leads',
        caption: 'Isenção de responsabilidade',
        description: 'A Enphase mostrará a faixa de preços fornecida por você, para cada preferência abaixo, para os proprietários. Será mostrada com uma isenção de responsabilidade informando que este preço é orçamentário e reflete o escopo de trabalho para um sistema típico apenas. O preço real está sujeito a alterações dependendo da localização, tipo/inclinação do telhado, atualização do painel elétrico e realocação do sistema para um local diferente.',
        atleaseOne: '* selecione pelo menos um serviço'
      },
      programreview: {
        title: 'visão geral do programa',
        description: 'Os proprietários contatam a Enphase para novas instalações, atualizações e manutenção contínua do sistema. Como um parceiro da Enphase, você agora tem a oportunidade de atender a esses proprietários por meio do programa Enphase Leads, que irá combiná-lo com os proprietários em potencial. Reveja os termos-chave abaixo e especifique as suas preferências para este programa.'
      },
      keyProgramTerms: {
        title: 'Termos-chave do programa',
        enphaseProduct: 'Como regra do programa, devem ser usados apenas produtos da Enphase',
        appointment: 'A Enphase ajudará no agendamento de consultas e fornecerá mais suporte conforme necessário',
        contact: 'Espera-se que as instaladoras entrem em contato com cada lead dentro de 2 dias úteis',
        project: 'O perfil do cliente e os detalhes de projeto de cada lead serão fornecidos antes do primeiro contato',
        verifiedAccount: 'A Enphase fornecerá leads qualificados gratuitos proveniente da sua área de atendimento ao cliente'
      },
      TurnKey: {
        title: 'Serviços Chave na Mão',
        description: `Serviços chave na mão significa que a instaladora fornece toda a lista de materiais, projeto, autorização, instalação e ativação, conforme aplicável. A instaladora faz a avaliação do projeto e da unidade antes de fornecer um orçamento detalhado. O preço indicado inclui o custo total estimado para o proprietário para que um sistema seja ativado.`,
        solar: {
          indicativePricing: 'Faixa de preço indicativa por Watt',
          quoteSizeIn: 'kW',
          main: 'Solar - Instalação',
          sub: 'Uma nova instalação do sistema solar.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instaladora',
              sub:
                'Fornece preços prontos para uso e adquire toda a lista de materiais necessária, como Módulos, Microinversores (ou, alternativamente, Módulos CA), caixa IQ Combiner, kit de acessórios, disjuntores, modem celular, cabos e prateleiras.'
            },
            assumptions: {
              main: 'Suposições',
              sub: 'A faixa de preço é para uma unidade típica e não inclui uma atualização do painel principal e telhado de tipo especial.'
            }
          }
        },
        storage: {
          indicativePricing: 'Faixa de preço indicativa por kWh',
          indicativePricingStorageSlabs: 'Preço indicativo por kWh',
          main: 'Armazenamento - Instalação',
          quoteSizeIn: 'kWh',
          sub: 'Uma nova instalação de sistema de armazenamento',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instaladora',
              sub:
                'Oferece preços prontos para uso e adquire toda a lista de materiais necessária, como armazenamento Encharge, interruptor Enpower, modem celular, kit de acessórios e cabos.'
            },
            assumptions: {
              main: 'Suposições',
              sub: 'A faixa de preço indicativa não inclui atualização do painel principal.'
            }
          }
        },
        microinverter: {
          indicativePricing: 'Faixa de preço indicativa por Watt',
          main: 'Microinversor - Atualização',
          quoteSizeIn: 'kW',
          sub:
            'Atualização de microinversor para um sistema solar da série M (por exemplo, M-215, M-250) para um novo sistema solar baseado em IQ que geralmente acompanha um "Armazenamento - Instalação"',
          sub2:
            'Atualização de microinversor para um sistema solar da série M (por exemplo, M-215, M-250) para um novo sistema solar baseado em IQ',
          subUS: 'Atualização do microinversor para um sistema solar existente para convertê-lo em um novo sistema solar baseado em IQ.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instaladora',
              sub: 'Fornece preços chave na mão e adquire toda a lista de materiais necessária.'
            },
            assumptions: {
              main: 'Suposições',
              sub: 'A faixa de preço indicativa não inclui atualização do painel principal e atualizações do painel solar.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Serviços apenas de instalação (para programas especiais)',
        titleUS: 'Serviços apenas de instalação',
        sub: '(por exemplo, proprietários com painéis solares baseados em M-190, amigos e família da Enphase)',
        description: 'Serviços de instalação apenas significa que o proprietário compra a lista de materiais da Enphase na Enphase Store. Todos os outros materiais e serviços são fornecidos diretamente pela instaladora (fiação, rack, projeto, autorização, instalação e ativação conforme aplicável).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Faixa de preços indicativa apenas para instalação por Watt',
          main: 'Solar - Instalação',
          sub: 'Nova instalação para programas especiais ou atualização completa de um sistema solar baseado em M-190/M-210/M-175/D380',
          subUS: 'Uma nova instalação de sistema solar',
          details: {
            homeOwner: {
              main: 'Proprietário',
              sub: 'As compras da lista de materiais exigida na Enphase Store, como Módulos CA, caixa do Combinador IQ, kit de acessórios e disjuntores.'
            },
            instller: {
              main: 'Instaladora',
              sub: 'Fornece estantes, fiação, permissão, instalação e ativação.'
            },
            assumptions: {
              main: 'Suposições',
              sub: `A faixa de preço indicativa não inclui atualização do painel principal e instalação de telhado de tipo especial.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Faixa de preços indicativos de instalação apenas por kWh',
          indicativePricingStorageSlabs: 'Preço indicativo apenas de instalação por kWh',
          main: 'Armazenamento - Instalação',
          sub:
            'Além de armazenamento para um sistema solar existente para programas especiais ou para um sistema solar baseado em M-190/M-210/M-175/D380',
          subUS: 'Uma nova instalação de sistema de armazenamento',
          details: {
            homeOwner: {
              main: 'Proprietário',
              sub:
                'Compra a lista de materiais necessária da loja Enphase, como armazenamento Encharge, interruptor Enpower, kit de acessórios, gateway Envoy (se necessário, caixa IQ Combiner, Modem celular e/ou TC de consumo).',
            },
            installer: {
              main: 'Instaladora',
              sub: 'Fornece permissão, instalação e ativação.'
            },
            assumptions: {
              main: 'Suposições',
              sub: `A faixa de preço indicativa não inclui atualização do painel principal.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Faixa de preços indicativa apenas para instalação por Watt',
          main: 'Microinversores - Atualização',
          sub: 'Atualização de microinversor para um sistema solar baseado em M-190/M-210/M-175/D380 para um novo sistema solar baseado em IQ que geralmente acompanha um "Armazenamento - Instalação"',
          sub2:
            'Atualização de microinversor para um sistema solar da série M (por exemplo, M-215, M-250) para um novo sistema solar baseado em IQ',
          subUS: 'Atualização do microinversor para um sistema solar existente para convertê-lo em um novo sistema solar baseado em IQ.',
          details: {
            homeOwner: {
              main: 'Proprietário',
              sub:
                'As compras exigidas da lista de materiais da loja Enphase, como microinversores, caixa IQ Combiner, kit de acessórios e disjuntores.' },
            installer: {
              main: 'Instaladora',
              sub: 'Fornece permissão, substituição, reativação e reciclagem de microinversores antigos.​'
            },
            assumptions: {
              main: 'Suposições',
              sub: 'A faixa de preço indicativa não inclui atualização do painel principal e alterações de rack.'
            }
          }
        }
     },
      omServices: {
        title: 'Serviços Enphase O&M',
        om: {
          main: 'Opt-in para serviços Enphase O&M',
          pre: '- Including Orphan Systems',
          sub: 'Os serviços de Operações e Manutenção (O&M) incluem o suporte e manutenção de sistemas Enphase existentes e Sistemas Órfãos (unidades com uma instaladora inativa). Todos os leads de O&M receberão detalhes completos e histórico de suporte da unidade. Para todos os leads de O&M, a garantia padrão do produto da Enphase será aplicada. A garantia de fabricação anterior não se aplica aos Sistemas Órfãos.'
        }
      },
      otherServices: {
        title: 'Outras preferências',
        buy: 'Estamos dispostos a comprar produtos de',
        acModule: {
          main: 'Estamos dispostos a instalar Módulos CA Energizados Enphase',
          sub1: 'Os Módulos CA Energizados Enphase ',
          sub2: 'combinam a mais recente tecnologia de microinversor da Enphase com os painéis solares de alta eficiência. Eles combinam estética e desempenho em um produto elegante que reduz o tempo de instalação ao combinar o inversor e o painel em uma única unidade. Ao selecionar esta opção, a Enphase irá combiná-lo com os proprietários que desejam instalar Módulos CA.'
        },
        enstore: {
          main: 'Enphase Store',
          sub1: 'Enphase Store ',
          sub2: 'é um balcão único para produtos Solar e Storage com entrega garantida. A loja não exige uma quantidade mínima de pedido e oferece entrega em tempo real e rastreamento online.​',
          subIndia: 'é um balcão único para produtos Solar, com entrega garantida. A loja não exige uma quantidade mínima de pedido e oferece entrega em tempo real e rastreamento online.​'
        },
        distributor: {
          main: 'Distribuidoras Enphase',
          sub1: 'Distribuidoras Enphase',
          sub2: ' fornecem todos os produtos Enphase e outros acessórios necessários para a sua solução Solar & Storage',
          subIndia: ' fornecer todos os produtos Enphase e outros acessórios necessários para a sua solução Solar'
        },
        permitAssistance: {
          main: 'Estamos interessados no serviço de assistência de autorização da Enphase',
          sub: 'A Enphase o ajudará com pacotes de permissão Solar e Storage para suas unidades, que você pode enviar à sua autoridade local para aprovação.'
        },
        financeProvider: {
          main: 'Oferecemos opções de financiamento para proprietários',
          no: 'Não',
          yes: 'Sim',
          financeProvider: 'Provedores de finanças',
          others: 'Outros provedores',
          addMultiple: 'até 3 (separados por vírgula)',
          requiredSelection: 'Seleção necessária',
          atLeastOneError: 'Provedores de finanças inválidos (pelo menos digite um nome de provedor quando "Outros provedores" for selecionado)'
        }
      },
      serviceArea: {
        name: 'ADICIONE ÁREAS DE SERVIÇO',
        sub: 'Nenhuma área adicionada',
        description: 'Adicione suas áreas de serviço. Isso é necessário para que a Enphase seja capaz de combiná-lo com possíveis leads proprietários.'
      
      },
      qualifyLeads: {
        mainSection: 'Você deseja que os representantes da Enphase qualifiquem os potenciais clientes através de uma chamada telefônica antes de compartilhar esses dados com você?',
        moreInfo: 'Indique se há alguma informação específica que você gostaria de obter da nossa parte em relação aos seus potenciais clientes.',
        infoWeCollect: 'Para saber quais informações coletamos como parte de nossos procedimentos de qualificação',
        subSection: 'Após obter a qualificação, você deseja que o potencial cliente seja transferido a um de seus representantes quando o proprietário estiver na chamada telefônica conosco?',
        details: 'Selecione um usuário administrador da sua empresa para o qual esses potenciais clientes devem ser transferidos',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      },
      textContentAu: {
        preference: [Object],
        programreview: [Object],
        keyProgramTerms: [Object],
        TurnKey: [Object],
        installationOnly: [Object],
        omServices: [Object],
        otherServices: [Object],
        serviceArea: [Object]
      },
      getLink: 'Obter link',
      linkSENewLeads: 'Link do Estimador de Sistema para novos leads',
      shareSELink: 'Compartilhe este link com seus clientes para ajudá-los a estimar o tamanho do sistema Enphase e enviar os detalhes deles para obter um lead em seu Enlighten Manager'
    }
  }
};

export default leadPreferences;
